const METHOD = {
    get : "get",
    put : "put",
    post : "post"
}

const ENDPOINTS = {
    all : "all",
    ongoing: "ongoing",
    unassigned: "unassigned"
}

export {METHOD, ENDPOINTS};